var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaveHeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 1.5H22.5V3H18V1.5ZM18 6H21V7.5H18V6ZM18 10.5H22.5V12H18V10.5ZM18 15H21V16.5H18V15Z",
    fill: "#286795"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 21H18C16.5017 20.9947 15.0391 20.5424 13.7994 19.7009C12.5598 18.8595 11.5995 17.6672 11.0415 16.2767C10.4835 14.8862 10.3532 13.3608 10.6673 11.8958C10.9815 10.4308 11.7257 9.09293 12.8048 8.05345C11.8247 7.69225 10.7892 7.50494 9.74475 7.49995C8.83169 7.4907 7.93242 7.7231 7.13817 8.17357C6.34391 8.62405 5.68292 9.27657 5.22225 10.065C3.74775 12.3262 3 16.005 3 21H1.5C1.5 15.7095 2.3295 11.7547 3.96525 9.2452C4.56297 8.24801 5.41062 7.42409 6.42439 6.85493C7.43815 6.28576 8.58292 5.99105 9.7455 5.99995H9.75C11.4351 6.02397 13.0924 6.43234 14.5958 7.19395C14.7116 7.25439 14.8096 7.34405 14.8802 7.45404C14.9507 7.56403 14.9913 7.69054 14.9978 7.82103C15.0044 7.95153 14.9768 8.08148 14.9177 8.19802C14.8587 8.31456 14.7702 8.41364 14.661 8.48545C13.5916 9.204 12.781 10.2468 12.3484 11.4604C11.9158 12.6739 11.884 13.9943 12.2578 15.2273C12.6316 16.4603 13.3912 17.5408 14.4248 18.3099C15.4584 19.079 16.7116 19.4962 18 19.5H22.5V21Z",
    fill: "#286795"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveHeight);
export default __webpack_public_path__ + "static/media/wave-height.e8e63a1f1183434d646b0b1a20fc53fe.svg";
export { ForwardRef as ReactComponent };